import { Share } from 'lucide-react'
import { burrowAppUrl } from '../../lib/env'
import { btn } from '../ui'

interface Props {
  /** Omit for an inert "Share" (preview). */
  onShare?: () => void
  /** The preview has its own sticky bar above this one. */
  sticky?: boolean
}

/**
 * The reader's header, on the shell of Burrow's nav bar (components/BurrowNav):
 * the same height, glass and hairline, with the logo on the left where the app
 * has it and Share on the right. Nothing else: the author, their writing count
 * and Follow live in the author block at the foot of the writing, and the
 * Reading light and light/dark switch float bottom-right (ReadingControls).
 */
export function ReaderHeader({ onShare, sticky = true }: Props) {
  return (
    <header className={`${sticky ? 'sticky top-0' : 'relative'} z-30 border-b border-border/40 bg-background/80 pt-[env(safe-area-inset-top)] backdrop-blur-lg`}>
      <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 items-center justify-between gap-3 font-sans text-[13px] font-medium md:h-16">
          <a href={burrowAppUrl} className="shrink-0 font-display text-[1.3rem] font-medium italic text-primary no-underline">
            Burrow
          </a>
          <button type="button" onClick={onShare} disabled={!onShare} aria-label="Share" className={`${btn.outline} disabled:cursor-default disabled:opacity-100`}>
            <Share size={14} aria-hidden />
            <span aria-hidden className="hidden sm:inline">
              Share
            </span>
          </button>
        </div>
      </div>
    </header>
  )
}
